export default "__VITE_ASSET__BBoBSdFE__"